import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';

const DatePicker = ({
  label,
  handleChange,
  minimumDate,
  value = null,
  isTime = false,
  maxDate = null,
  required = true,
  returnFormat,
  disabled = false,
  requiredMessage,
}) => {
  const [date, setDate] = useState(null);
  const [isFilled, setIsFilled] = useState(null);
  const [isFocus, setIsFous] = useState(false);
  const [isRequired, setIsRequired] = useState(true);

  useEffect(() => {
    setIsRequired(required);
  }, [required]);

  useEffect(() => {
    setDate(value);
  }, [value]);

  const handleDateChange = (jsdate, dateString) => {
    if(dateString=='Invalid date'){
      setDate(null);
      handleChange(null);
    }else{
      setDate(dateString);
      handleChange(dateString);
    }
  };

  const handleDateHide = () => {
    if (!date) {
      setIsFous(false);
      setIsFilled(true);
    } else {
      setIsFilled(null);
    }
  };

  useEffect(() => {
    if (date !== null) {
      if (date !== '' && date !== undefined) {
        setIsFous(true);
        setIsFilled(false);
      } else {
        setIsFous(false);
      }
    }
  }, [date]);

  return (
    <FormGroup
      className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
      style={{ width: '100%' }}
    >
      <div className="datepicker-input-wrapper" style={{ width: '100%', flexShrink: 0 }}>
      <DatePickerInput
        onChange={handleDateChange}
        value={date}
        autoClose
        onShow={() => setIsFous(true)}
        onHide={handleDateHide}
        minDate={minimumDate}
        closeOnClickOutside
        showOnInputClick
        locale="en"
        className={`my-custom-datepicker-component ${isRequired === true && !date ? 'activeAnkInput' : ''}`}
        required={isRequired}
        displayFormat="DD-MM-YYYY"
        returnFormat={returnFormat ? returnFormat : 'DD-MM-YYYY'}
        maxDate={maxDate}
        disabled={disabled}
      />
      </div>
      <label>
        {label}
        <span className="label-star" style={{ color: 'red' }}>
          {isRequired ? ' *' : ' '}
        </span>
      </label>

      <label
        className={`error date-error date_error ${
          isFilled === true && isFilled !== null ? 'd-block' :
              ''
        }`}
      >
        {isRequired === true && !date
          ? requiredMessage ?? localization.requiredDate
          : ''}
      </label>

    </FormGroup>
  );
};

DatePicker.propTypes = {
  label: PropTypes.string,
  handleChange: PropTypes.func,
  requiredMessage: PropTypes.string,
};

DatePicker.defaultProps = {
  requiredMessage: undefined,
};

export default DatePicker;
